module.exports = __webpack_public_path__ + "static/surface-c9ec3b34e36a323f47b373b5a66a876a.png";